import { render } from "./AdmissionFeeReminderAlert.vue?vue&type=template&id=7d067529"
import script from "./AdmissionFeeReminderAlert.vue?vue&type=script&lang=js"
export * from "./AdmissionFeeReminderAlert.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/v3/Modal/AdmissionFeeReminderAlert.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7d067529"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7d067529', __exports__)) {
    api.reload('7d067529', __exports__)
  }
  
  module.hot.accept("./AdmissionFeeReminderAlert.vue?vue&type=template&id=7d067529", () => {
    api.rerender('7d067529', render)
  })

}


export default __exports__